<template>
  <div class="layout default">
		<Navbar />
		<div id="content">
			<router-view />
		</div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'default',
	components: {
		Navbar
	}
}
</script>

<style lang="sass">
@import '../assets/css/smart-grid'

#content
	+col()
	+size(7)
	+size-md(12)
	+shift-left(5)
	+shift-md-left(0)
	margin-top: 2.5rem
	margin-bottom: 2.5rem

@media screen and (max-width: $break_md)
	#content
		margin-top: 6rem

@media screen and (max-width: $break_xs)
	#content
		margin-top: 9rem
</style>
